import { render, staticRenderFns } from "./ParametrosSistemaCliente.vue?vue&type=template&id=3e40b499&"
import script from "./ParametrosSistemaCliente.vue?vue&type=script&lang=ts&"
export * from "./ParametrosSistemaCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports